import {Component, OnInit} from '@angular/core';
import {Setup} from "../../../Models/setup";
import {SetupService} from "../../../Services/setup.service";

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    setup: Setup = new Setup();

    constructor(private setupSer: SetupService) {
    }

    ngOnInit(): void {
        this.setupSer.getSetup().subscribe(x => {
            this.setup = x;
        })
    }

}
